import React from 'react';
import TolTag from '../../shared/tol-tag';
import RelativeTime from '../relative-time';
import Bookmark from '../bookmark';
import {
  Container,
  Secondary,
  Separator,
  TopLine,
  BottomLine,
} from './styles';
import { captionProps, defaultCaptionProps } from './prop-types';

export default function MobileOrTablet({ wire }) {
  const {
    caption,
    campaign,
    timestamp,
    isSponsored,
    showBookmarkHint,
  } = wire;

  return (
    <Container>
      <TopLine>
        {!!isSponsored && (
          <Secondary>
            sponsored
          </Secondary>
        )}
        {!!campaign && <TolTag {...campaign} />}
      </TopLine>
      <BottomLine>
        {!!caption && (
          <span className="main">
            <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
          </span>
        )}
        {timestamp && (
          <>
            <Separator className="separator">&bull;</Separator>
            <span className="wire__date secondary">
              <RelativeTime timestamp={timestamp} />
            </span>
          </>
        )}
        <Bookmark wire={wire} showBookmarkHint={showBookmarkHint} />
      </BottomLine>
    </Container>
  );
}

MobileOrTablet.propTypes = captionProps;
MobileOrTablet.defaultProps = defaultCaptionProps;
